// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"370":"c83647760f32b5c4","905":"ccaaa03a42cacddc"}[chunkId] + ".js";
};